import axios from 'axios';
import { Questionaire } from '../models/QEQuestion';

export const fetchQuestionnaire = async (href = 'forms/gfb/latest') => {
  const response = await axios.get<Questionaire>(href);

  return response.data;
};
